module.exports = __webpack_public_path__ + "img/skeleton1.93e4ac51.jpg";